export const RolloverOtpApi = {
  SEND_ROLLOVER_SMS: 'rollover-otp-api/sendRolloverSms',
  VERIFY_ROLLOVER_SMS: 'rollover-otp-api/verifyRolloverSms',
};
